
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartPaperSymbolIec as ObiChartPaperSymbolIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-paper-symbol-iec.js';
 
 
 

 
 export const ObiChartPaperSymbolIec = createComponent({
   react: React,
   tagName: 'obi-chart-paper-symbol-iec',
   elementClass: ObiChartPaperSymbolIecElement,
   events: {
     
   }
  });
 
 